import { render, staticRenderFns } from "./AddSchoolName.vue?vue&type=template&id=53b9a656&scoped=true&"
import script from "./AddSchoolName.vue?vue&type=script&lang=js&"
export * from "./AddSchoolName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b9a656",
  null
  
)

export default component.exports